import { FieldErrors, useFormContext } from 'react-hook-form'
import { BefehlFormField } from '../Generic'
import { Input } from '../../form'
import { useTranslation } from 'react-i18next'
import { Befehl31FormData } from './schema'
import { useMemo } from 'react'

export interface Feld31_16FormProps {
  readOnly: boolean
  'data-testid': string
  activateEmptyFieldWarnings?: boolean
  errors?: FieldErrors
}

export default function Feld31_16Form({
  readOnly,
  'data-testid': testId,
  errors,
  activateEmptyFieldWarnings = false
}: Readonly<Feld31_16FormProps>) {
  const { t } = useTranslation('ui-befehle')

  const { control, watch, formState } = useFormContext<Befehl31FormData>()

  const fieldErrors = useMemo(() => {
    return errors ?? formState.errors
  }, [errors, formState.errors])

  const auftrag_31_15 = watch('auftrag31_15')

  return (
    <div className="flex flex-col">
      <BefehlFormField
        name="feld31_16"
        control={control}
        label={t('befehle.31.text.nr_einfahrweiche')}
        readOnly={readOnly}
        activateEmptyWarning={activateEmptyFieldWarnings && auftrag_31_15}
        data-testid={`${testId}-einfahrweiche`}
        render={({ field }) => (
          <Input
            {...field}
            name={field.name}
            label={t('befehle.31.text.nr_einfahrweiche')}
            errors={fieldErrors}
            className="w-auto min-w-8"
            data-testid={`${testId}-inner`}
            disabled={!auftrag_31_15}
          />
        )}
      />
      <div>
        <span
          className={auftrag_31_15 ? '' : 'text-gray-500 opacity-60'}
          data-testid={`${testId}-label`}
        >
          {t('befehle.31.label.feld31_16')}
        </span>
      </div>
    </div>
  )
}
